import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {useUpdateWorkflowSearchConditionMutation} from 'api';
import {SearchCondition} from './Types';

type Props = {
  salesforceLeadSearchConditions: SearchCondition[];
  setSalesforceLeadSearchConditions: React.Dispatch<
    React.SetStateAction<SearchCondition[]>
  >;
  index: number;
};

export default ({
  salesforceLeadSearchConditions,
  setSalesforceLeadSearchConditions,
  index,
}: Props) => {
  const {workflowId} = useParams<{poolId: string; workflowId: string}>();

  const [updateWorkflowSearchCondition] =
    useUpdateWorkflowSearchConditionMutation({
      refetchQueries: ['workflowProspectPoolCountsByStatus'],
    });

  return (
    <CrossWrapper>
      <svg
        onClick={() => {
          let newFilters: SearchCondition[] = [
            ...salesforceLeadSearchConditions,
          ];
          newFilters = newFilters.filter(
            (item) => Object.keys(item).length !== 0,
          );
          newFilters.splice(index, 1);
          setSalesforceLeadSearchConditions([...newFilters]);
          updateWorkflowSearchCondition({
            variables: {
              uuid: workflowId,
              attributes: {
                salesforceLeadSearchConditions: newFilters,
              },
            },
          });
        }}
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.916016 9.08366L9.08268 0.916992M0.916016 0.916992L9.08268 9.08366L0.916016 0.916992Z"
          stroke="var(--text-color-3)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </CrossWrapper>
  );
};

const CrossWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
